import type {
  Filters,
  ReportResponse,
  ReportType,
  Summary
} from "./types";

export async function loadSummary(token: string): Promise<Summary> {
  return apiRequest<Summary>("/api/report/summary", token);
}

export async function loadReport(
  token: string,
  type: ReportType,
  filters: Filters,
  signal?: AbortSignal
): Promise<ReportResponse> {
  const search = new URLSearchParams({
    type,
    search: filters.search,
    position: filters.position,
    status: filters.status,
    page: String(filters.page),
    pageSize: type === "collabs" ? "500" : "200"
  });
  if (filters.absenceMonths) {
    search.set("absenceMonths", filters.absenceMonths);
  }
  return apiRequest<ReportResponse>(
    `/api/report?${search.toString()}`,
    token,
    { signal }
  );
}

export async function refreshReport(token: string): Promise<void> {
  await apiRequest("/api/report/refresh", token, { method: "POST" });
}

export async function loadSyncStatus(
  token: string
): Promise<{ sync: { status?: string; started_at?: string } | null }> {
  return apiRequest("/api/report/status", token);
}

export async function downloadExport(
  token: string,
  type: ReportType,
  format: "csv" | "xlsx",
  filters: Filters
): Promise<void> {
  const search = new URLSearchParams({
    type,
    format,
    search: filters.search,
    position: filters.position,
    status: filters.status
  });
  if (filters.absenceMonths) {
    search.set("absenceMonths", filters.absenceMonths);
  }
  const response = await fetch(`/api/export?${search.toString()}`, {
    headers: { authorization: `Bearer ${token}` }
  });
  if (!response.ok) throw new Error("Не удалось сформировать файл.");
  const blob = await response.blob();
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = `${type}-report.${format}`;
  link.click();
  URL.revokeObjectURL(href);
}

async function apiRequest<T>(
  url: string,
  token: string,
  init: RequestInit = {}
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("authorization", `Bearer ${token}`);
  if (init.body !== undefined && init.body !== null) {
    headers.set("content-type", "application/json");
  }
  const response = await fetch(url, {
    ...init,
    headers
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      typeof payload.message === "string"
        ? payload.message
        : "Сервер приложения вернул ошибку."
    );
  }
  return payload as T;
}
